export const FORM_ERROR_SECTIONS = {
  CLOSURES: 'closures',
  NOTIFY_USERS: 'notifyUsers',
  NOTIFY_CONTACTS: 'notifyContacts',
};

export const createEmptyFormErrors = () => ({
  name: null,
  [FORM_ERROR_SECTIONS.CLOSURES]: {},
  [FORM_ERROR_SECTIONS.NOTIFY_USERS]: {},
  [FORM_ERROR_SECTIONS.NOTIFY_CONTACTS]: {},
});

export const hasFormErrors = (errors) =>
  Object.values(errors).some((sectionErrors) => {
    if (sectionErrors == null) return false;
    if (typeof sectionErrors === 'object') {
      return Object.keys(sectionErrors).length > 0;
    }

    return Boolean(sectionErrors);
  });

export const reindexIndexedSectionErrors = (sectionErrors, removedIndex) => {
  const nextErrors = {};

  Object.entries(sectionErrors).forEach(([index, error]) => {
    const numericIndex = Number(index);

    if (numericIndex < removedIndex) {
      nextErrors[numericIndex] = error;
    } else if (numericIndex > removedIndex) {
      nextErrors[numericIndex - 1] = error;
    }
  });

  return nextErrors;
};

export const clearFormErrorEntry = (errors, { section, key }) => {
  const sectionErrors = errors[section];

  if (sectionErrors == null) return errors;

  if (key === undefined) {
    const emptyErrors = createEmptyFormErrors();

    return {
      ...errors,
      [section]: emptyErrors[section],
    };
  }

  if (typeof sectionErrors !== 'object') return errors;

  const nextSectionErrors = { ...sectionErrors };
  delete nextSectionErrors[key];

  return {
    ...errors,
    [section]: nextSectionErrors,
  };
};
